import React from 'react'
import styled from '@emotion/styled'
import { Flex, Icon } from 'shared/ui'
import themeVars from 'ui_theme/site/globals/site.variables'

const DeleteIcon = styled(props => <Icon name="close" {...props} />)`
  margin-left: 2px;
  opacity: 0.3;
  transition: opacity 0.2s ease-out;

  &:hover {
    opacity: 1;
  }

  @media print {
    display: none;
  }
`

const Container = styled(Flex)`
  background-color: ${props => props.color};
  border-radius: ${themeVars.defaultBorderRadius};
  line-height: 1.73;
  font-size: 11px;
  padding: 1px 4px 1px 4px;
  color: ${props => props.theme.color.monochrome.white};
  margin-right: 8px;
  margin-top: 8px;

  @media print {
    color: ${props => props.theme.color.monochrome.black} !important;
    background-color: white !important;
    border: 1px solid currentColor;

    & * {
      color: inherit !important;
      background-color: inherit !important;
    }
  }
`

export default function Tag({ color, name, onDeleteClick }) {
  return (
    <Container color={color} className="grui items-center">
      <div>{name}</div>
      <DeleteIcon
        name="close"
        size="xsmall"
        onClick={onDeleteClick}
        color="color.monochrome.white"
      />
    </Container>
  )
}
